import { connect } from 'react-redux';
import { disallow } from 'arts/actions/mail_subscriptions';
import Footer from './footer';

const mapStateToProps = ({ mailSubscription }) => ({
  allowMailSubscription: mailSubscription.allow
});

export default connect(mapStateToProps, { disallow })(Footer);
